import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import { ApiError, ExtendedApiResult } from 'common/repositories/common.model';

import {
  getProductAdjustmentInput,
  getProductsAdjustmentInput,
  ProductAdjustmentLiteModel,
  ProductAdjustmentModel,
} from './model';

export function useGetProductsAdjustment(
  input?: getProductsAdjustmentInput,
  options?: UseQueryOptions<
    ExtendedApiResult<ProductAdjustmentLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<ProductAdjustmentLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['product-adjustments', input?.params],
      () =>
        QueryFetchFunction({
          url: 'product-adjustments',
          params: input?.params,
        }),
      options,
    ),
    ProductAdjustmentLiteModel,
  );
}

export function useGetProductAdjustment(
  input?: getProductAdjustmentInput,
  options?: UseQueryOptions<
    ExtendedApiResult<ProductAdjustmentModel>,
    ApiError
  >,
) {
  return QueryTransformer(
    useQuery(
      ['product-adjustments', input?.id],
      () =>
        QueryFetchFunction({
          url: `product-adjustments/${input?.id}`,
        }),
      options,
    ),
    ProductAdjustmentModel,
  );
}

export function getProductsAdjustmentKey(input?: getProductsAdjustmentInput) {
  return ['product-adjustments', input?.params].filter(Boolean);
}

export function getProductAdjustmentKey(input?: getProductAdjustmentInput) {
  return ['product-adjustments', input?.id].filter(Boolean);
}
